<td class="mat-cell p-4 my-auto" [attr.colspan]="99">
    <span *ngIf="!loading && customMessage">{{ customMessage }}</span>
    <span *ngIf="loading">Gathering data ...</span>
    <span *ngIf="!customMessage && !loading">No data <span *ngIf="filterCount > 0">matching search criteria</span> returned</span>
</td>
